<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button *ngIf="dismissButtonEnable" type="button" class="btn-close shadow-none" data-bs-dismiss="modal" (click)="dismiss.emit()"></button>
</div>
<div class="modal-body">
  <div #modalBody><ng-content #modalBody select="[body]"></ng-content></div>
  <div *ngIf="!modalBody.innerHTML.trim()">
    <p translate>{{ text }}</p>
  </div>
</div>
<div *ngIf="!disabledFooter" class="modal-footer" [ngClass]="extraFooterClasses">
  <div #modalFooter><ng-content select="[footer]"></ng-content></div>
  <div *ngIf="!modalFooter.innerHTML.trim()">
    <wsb-atlas-button
      *ngIf="cancelButtonEnable"
      variant="secondary"
      class="secondary me-3"
      data-dismiss="modal"
      (btnClick)="dismiss.emit()"
      [label]="cancelButtonText"
    ></wsb-atlas-button>
    <wsb-atlas-button
      #submitBtn
      wsbAppDebounceClick
      (debounceClick)="primary.emit()"
      [buttonRef]="submitBtn"
      *ngIf="primaryButtonEnable"
      variant="primary"
      [disabled]="primaryDisabled"
      [label]="primaryButtonText"
      [loading]="loading"
    ></wsb-atlas-button>
  </div>
</div>
